/* Moyoni analytics: pushes GA4-style events to window.dataLayer. No tags are loaded here. */
(function(){
  window.dataLayer=window.dataLayer||[];
  function push(name,params){try{window.dataLayer.push({event:name,ecommerce:params||{}})}catch(e){}}
  function item(p){return {item_id:String(p.id||''),item_name:p.title||'',price:p.price!=null?p.price/100:undefined,item_variant:p.variant||undefined}}
  // view_item on product pages
  document.addEventListener('DOMContentLoaded',function(){
    var el=document.querySelector('[data-moyoni-handle]');
    if(el){fetch('/products/'+el.getAttribute('data-moyoni-handle')+'.js').then(function(r){return r.json()}).then(function(p){
      push('view_item',{currency:'GBP',value:p.price/100,items:[item(p)]})}).catch(function(){});}
    // select_item on card click
    document.addEventListener('click',function(e){
      var a=e.target.closest&&e.target.closest('.card-wrapper a[href*="/products/"]');
      if(a){push('select_item',{items:[{item_name:(a.textContent||'').trim().slice(0,120),item_list_name:document.title}]})}
    },true);
  });
  // add_to_cart: observe Shopify cart add requests
  var of=window.fetch;
  window.fetch=function(u,o){
    var res=of.apply(this,arguments);
    try{var url=typeof u==='string'?u:(u&&u.url)||'';
      if(/\/cart\/add/.test(url)){res.then(function(r){return r.clone().json()}).then(function(j){
        if(j&&j.items){j=j.items[0]}
        if(j&&j.product_id){push('add_to_cart',{currency:'GBP',value:(j.final_line_price||j.price*(j.quantity||1))/100,items:[{item_id:String(j.product_id),item_name:j.product_title,item_variant:j.variant_title,price:j.price/100,quantity:j.quantity}]})}
      }).catch(function(){})}
    }catch(e){}
    return res;};
  // wishlist
  document.addEventListener('moyoni:wishlist',function(e){
    push(e.detail.added?'add_to_wishlist':'remove_from_wishlist',{items:[{item_id:e.detail.handle}]});});
})();
